<adapt-context-sidebar-implementation-kit [articleId]="ImplementationKitArticle.BuildCulturalLeadership"
                                          context="page"></adapt-context-sidebar-implementation-kit>

<adapt-clf-grid></adapt-clf-grid>
